export default "__VITE_ASSET__d43fbaf2__"